import React from "react";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          {/* Logo on the left */}
          <Link to="/" className="logo-link">
            <img
              src="/images/logo.png"
              alt="Topup Connect Logo"
              className="logo-img"
            />
          </Link>

          {/* Navigation menu in the center */}
          <nav className="navigation">
            <ul className="nav-list">
              <li className="nav-item">
                <Link to="/" className="nav-link">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/about-us" className="nav-link">
                  About Us
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/services" className="nav-link">
                  Services
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/contact-us" className="nav-link">
                  Contact Us
                </Link>
              </li>
            </ul>
          </nav>

          {/* Login button on the right */}
          {/* <div className="auth-actions">
            <a href="https://app.topupconnect.in" className="login-button">
              Login
            </a>
          </div> */}
        </div>
      </div>
    </header>
  );
};

export default Header;
